import React from 'react';

import classes from './ScenarioSection.module.scss';
import { ModalInputBox } from '../../../../shared/components/modals';

type ScenarioSectionProps = {
  scenarioCase: string;
  scenarioId: number;
  message: string;
};

const ScenarioSection = ({ scenarioCase, scenarioId, message }: ScenarioSectionProps) => {
  return (
    <ModalInputBox
      title={scenarioCase}
      adornment={
        <div className={classes.adornment}>
          <span className={classes.label}>Scenario ID:</span>
          <span className={classes.value}>{scenarioId}</span>
        </div>
      }
    >
      <div>{message}</div>
    </ModalInputBox>
  );
};

export { ScenarioSection };
